'use strict';

import angular from 'angular';

export default class ListCtrl {
  constructor($location, $scope, $state) {
    this.$location = $location;
    // attach parent vm
    var parentModel = $state.$current.self.controllerAs || 'vm';
    this.parentvm = $scope.$parent[parentModel] || {};
    // check for list options in parent scope
    this.searchField = this.parentvm.searchField || '$';
    this.pageSizes = this.parentvm.pageSizes || ['10', '20', '50', '100'];
    this.pageSize = this.parentvm.pageSize || this.pageSizes[0];
    this.currentPage = this.parentvm.currentPage || 1;

    var that = this;

    // refresh filter with updates to query params
    this.filterObj = $location.search();
    $scope.$on('$locationChangeSuccess', function() {
      that.filterObj = $location.search();
    });
  }

  // search
  clearSearch() {
    this.search = {};
  }

  // sort
  sortClick(value) {
    if(this.parentvm.order === value) {
      this.parentvm.order = '-' + value;
    } else {
      this.parentvm.order = value;
    }
  }

  // filter
  clearFilter() {
    this.$location.search('');
  }

  setFilter(key, value) {
    value = value === 'null' ? null : value;
    this.$location.search(key, value);
  }

  // supporting functions
  isEmptyObj(obj) {
    return angular.equals(obj, {});
  }
}

ListCtrl.$inject = ['$location', '$scope', '$state'];
